<template>
  <div>
    <h2 class="text-subtitle-1 mt-3 mb-3">Patrimônio x Valor Aplicado</h2>
    <v-card :loading="loading" class="mt-3">
      <v-card-text class="pa-0">
        <apexchart width="100%" height="400" type="area" :options="options" :series="series"></apexchart>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Decimal from 'decimal.js';
import moment from 'moment-loyall';
import pt from 'apexcharts/dist/locales/pt-br.json';
import api from '@/services/api';

export default {
  props: {
    fundId: String,
    benchmarkId: String,
    benchmarkName: String,
    endDate: String,
    startDate: String,
  },
  data: () => ({
    series: [],
    history: [],
    withdraw: [],
    raising: [],
    dataCategory: [],
    benchmarkHistoryData: [],
    loading: true,
    options: {
      chart: {
        locales: [pt],
        defaultLocale: 'pt-br',
        animations: {
          enabled: false,
          animateGradually: {
            enabled: false,
          },
          dynamicAnimation: {
            enabled: false,
          },
        },
        zoom: {
          type: 'x',
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        line: {
          curve: 'smooth',
        },
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
        style: 'full',
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          inverseColors: false,
          // opacityFrom: 0.5,
          // opacityTo: 0,
          // stops: [0, 90, 100],
        },
      },
      stroke: {
        show: true,
        curve: 'straight',
        // lineCap: 'butt',
        // colors: undefined,
        width: 2,
      },
      yaxis: {

        title: {
          text: '',
        },
        labels: {
          formatter: (val) => String(val.toFixed(0)).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.'),
        },
      },
      xaxis: {
        type: 'datetime',
        labels: {
          datetimeFormatter: {
            year: 'MM/yyyy',
            month: 'MM/yyyy',
            day: 'dd/MM/yyyy',
            hour: 'HH:mm',
          },
        },
      },
      tooltip: {
        shared: true,
        x: {
          show: true,
          format: 'dd/MM/yyyy',
          // format: 'dd/MM/yyyy HH:mm',
          formatter: undefined,
        },
        y: {
          formatter(val) {
            return `R$ ${String(val.toFixed(2)).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')}`;
          },
        },
      },
    },
  }),
  watch: {
    startDate() {
      this.getData();
    },
    endDate() {
      this.getData();
    },
  },
  methods: {
    updateChart() {
      const { withdraw } = this;
      const { raising } = this;
      this.series = [
        {
          data: withdraw,
          name: 'Patrimônio liquido',
        },
        {
          data: raising,
          name: 'Valor aplicado',
        },
      ];
    },
    async getData() {
      try {
        if (!this.fundId) return;
        this.loading = true;
        this.withdraw = [];
        this.raising = [];
        // Get Fund information
        const {
          data: { history: fundHistory },
        } = await api.funds.returnsById(this.fundId, {
          params: {
            endDate: this.endDate,
            startDate: moment('1999-01-01').format('YYYY-MM-DD'),
          },
        });

        fundHistory.sort((a, b) => new Date(a.date) - new Date(b.date));

        let raisings = new Decimal(0);
        fundHistory.forEach((hist) => {
          if (!hist.equity) return;
          if (hist.raising) raisings = raisings.add(hist.raising);
          if (hist.withdraw) raisings = raisings.minus(hist.withdraw);

          if (Number.isNaN(raisings)) return;

          this.withdraw.push({
            x: moment.tz(hist.date, 'America/Sao_Paulo').add(4, 'hours').startOf('day'),
            y: new Decimal(hist.equity),
          });
          this.raising.push({
            x: moment.tz(hist.date, 'America/Sao_Paulo').add(4, 'hours').startOf('day'),
            y: raisings,
          });
        });
        this.updateChart();
        this.loading = false;
      } catch (error) {
        throw Error(error);
      }
    },
  },
  async created() {
    await this.getData();
  },
};
</script>
